import {SOURCES, SOURCES_TO_DISPLAY} from '../../../../../utils/constants.js';
import {DISABLE_REASONS} from '../reasons.js';

/**
 * Candex purchase requests.
 * @param {Object} ctx
 * @return {string|false}
 */
export function sourceCandex(ctx) {
    return ctx.source === SOURCES.CANDEX ? DISABLE_REASONS.SOURCE_CANDEX : false;
}

/**
 * Candex lines whose price comes from the standard template.
 * @param {Object} ctx
 * @return {string|false}
 */
export function priceFromCandex(ctx) {
    if (!ctx.material?.arePriceDataFromST || ctx.source !== SOURCES.CANDEX) {
        return false;
    }
    return DISABLE_REASONS.SOURCE_CANDEX;
}

/**
 * PunchOut purchase requests.
 * @param {Object} ctx
 * @return {string|false}
 */
export function sourcePunchOut(ctx) {
    const isPunchOut = ctx.source === SOURCES.PUNCHOUT || ctx.sourceToDisplay === SOURCES_TO_DISPLAY.PUNCHOUT;
    return isPunchOut ? DISABLE_REASONS.SOURCE_PUNCHOUT : false;
}

/**
 * PunchOut lines whose price comes from the standard template.
 * @param {Object} ctx
 * @return {string|false}
 */
export function priceFromPunchOut(ctx) {
    if (!ctx.material?.arePriceDataFromST || ctx.sourceToDisplay !== SOURCES_TO_DISPLAY.PUNCHOUT) {
        return false;
    }
    return DISABLE_REASONS.SOURCE_PUNCHOUT;
}

/**
 * NestBuy lines that are not transport costs.
 * @param {Object} ctx
 * @return {string|false}
 */
export function sourceNestBuy(ctx) {
    if (!ctx.material || ctx.source !== SOURCES.NESTBUY || ctx.material.transportCosts) {
        return false;
    }
    return DISABLE_REASONS.SOURCE_NESTBUY;
}

/**
 * NestBuy lines, including transport costs.
 * @param {Object} ctx
 * @return {string|false}
 */
export function sourceNestBuyAny(ctx) {
    return ctx.source === SOURCES.NESTBUY ? DISABLE_REASONS.SOURCE_NESTBUY : false;
}

/**
 * NSC lines that are not transport costs.
 * @param {Object} ctx
 * @return {string|false}
 */
export function sourceNsc(ctx) {
    if (!ctx.material || ctx.material.transportCosts) {
        return false;
    }
    if (ctx.sourceToDisplay !== SOURCES_TO_DISPLAY.NESTLE_SUPPLIER_CATALOGUE) {
        return false;
    }
    return DISABLE_REASONS.SOURCE_NSC;
}

/**
 * PSL lines whose price comes from the standard template.
 * @param {Object} ctx
 * @return {string|false}
 */
export function sourcePsl(ctx) {
    if (!ctx.material?.arePriceDataFromST || ctx.source !== SOURCES.PSL) {
        return false;
    }
    return DISABLE_REASONS.SOURCE_PSL;
}

/**
 * FO way of buying.
 * @param {Object} ctx
 * @return {string|false}
 */
export function wayOfBuyingFo(ctx) {
    return ctx.wayOfBuying?.value === 'FO' ? DISABLE_REASONS.WAY_OF_BUYING_FO : false;
}

/**
 * Free-item lines lock price fields unless the way of buying is FO.
 * @param {Object} ctx
 * @return {string|false}
 */
export function freeItem(ctx) {
    if (!ctx.material?.freeItem || ctx.wayOfBuying?.value === 'FO') {
        return false;
    }
    return DISABLE_REASONS.FREE_ITEM;
}
